import React, {Fragment} from 'react';

import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Box,
    Grid,
    SvgIcon,
    Typography,
    withStyles,
} from '@material-ui/core';
import PropTypes from 'prop-types';
import type {AccordionProps} from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import {AccordionShape} from 'commons/shapes';
import {InferPropTypes} from 'commons/types/Types';
import {AccordionStyles} from 'assets/tss/layouts/components';
import {EfeAccordionValues} from 'commons';

EfeAccordion.propTypes = {
    values: PropTypes.arrayOf(AccordionShape.isRequired).isRequired,
};

function EfeAccordion(
    props: InferPropTypes<typeof EfeAccordion.propTypes & AccordionProps, typeof AccordionStyles>
) {
    const {classes, values, ...other} = props;

    return (
        <Fragment>
            {values.map((value: EfeAccordionValues, index: number) => {
                return (
                    <Accordion
                        square
                        disabled={value.disabled}
                        expanded={value.expanded}
                        className={classes.root}
                        key={`accordion-${index}`}
                        {...other}>
                        <AccordionSummary
                            aria-label='Expand'
                            className={classes.header}
                            expandIcon={value.expandIcon && <ExpandMoreIcon />}>
                            <Grid item xs={12}>
                                <Box
                                    display='flex'
                                    flexDirection='row'
                                    justifyContent='center'
                                    alignItems={'center'}
                                    mt={2}>
                                    <Grid container spacing={2}>
                                        <Typography className={classes.header} variant={'h5'}>
                                            {value.icon && (
                                                <SvgIcon className={classes.icon} color='primary'>
                                                    {value.icon}
                                                </SvgIcon>
                                            )}
                                            {value.title}
                                        </Typography>

                                        <Grid item xs={12} sm={12}>
                                            <Typography
                                                className={classes.header}
                                                variant={'caption'}>
                                                {value.subtitle}
                                            </Typography>
                                        </Grid>
                                    </Grid>
                                </Box>{' '}
                            </Grid>
                        </AccordionSummary>
                        <AccordionDetails className={classes.body}>
                            <Grid
                                container
                                spacing={2}
                                alignContent='center'
                                justifyContent='center'>
                                <Grid item xs={12}>
                                    <Box pb={6}>{value.reactElement}</Box>
                                </Grid>
                            </Grid>
                        </AccordionDetails>
                    </Accordion>
                );
            })}
        </Fragment>
    );
}

export default withStyles(AccordionStyles)(EfeAccordion);
